import http from "../httpService";
import { apiUrl } from "../../../config.js";

const apiEndpoint = apiUrl + "/crm/ticket/";

export function saveTicket(ticket) {
  return http.post(apiEndpoint, ticket);
}

export function getTickets() {
  return http.get(apiEndpoint);
}

export function getTicketMessages(ticketID) {
  return http.get(apiEndpoint + "ticket-messages/" + ticketID);
}

export function getTicketDetail(ticketID) {
  return http.get(apiEndpoint + "ticket-detail/" + ticketID);
}

export function changeTicketService(ticketService) {
  return http.post(apiEndpoint + "change-ticket-service", ticketService);
}

export function claimTicket(ticketID) {
  return http.post(apiEndpoint + "claim-ticket", {
    ticketID: ticketID,
  });
}

export function assignItem(item) {
  return http.post(apiEndpoint + "assign-item", item);
}

export function replyTicketEmail(ticketID, emailTo, replyMessage) {
  return http.post(apiEndpoint + "reply-ticket-email", { ticketID: ticketID, emailTo: emailTo, replyMessage: replyMessage });
}
